/**
 * @generated SignedSource<<8307d24646dec2179f7b4020c61d570b>>
 * @relayHash 86994beb11f4ef7c8af21523816aa062
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d25c1a9e348f5cef268af0c5a574df9a275e97bc5093fe2bce8d15900b232a1c

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GlobalShortcutsRelayClientQuery$variables = {
  cloudId: string;
};
export type GlobalShortcutsRelayClientQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useGlobalShortcutsDataRelay">;
};
export type GlobalShortcutsRelayClientQuery = {
  response: GlobalShortcutsRelayClientQuery$data;
  variables: GlobalShortcutsRelayClientQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v2 = {
  "kind": "ScalarField",
  "name": "productType"
},
v3 = {
  "kind": "ScalarField",
  "name": "url"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GlobalShortcutsRelayClientQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "useGlobalShortcutsDataRelay"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GlobalShortcutsRelayClientQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          }
        ],
        "kind": "LinkedField",
        "name": "appSwitcher_availableProductsBySite",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "products",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ],
                    "type": "AppSwitcherSingleUrlProduct"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      {
                        "concreteType": "AppSwitcherProductSite",
                        "kind": "LinkedField",
                        "name": "sites",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "siteId"
                          },
                          (v3/*: any*/)
                        ]
                      }
                    ],
                    "type": "AppSwitcherSiteScopedProduct"
                  }
                ]
              }
            ],
            "type": "AppSwitcherAvailableProductsBySite"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ],
            "type": "QueryError"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "d25c1a9e348f5cef268af0c5a574df9a275e97bc5093fe2bce8d15900b232a1c",
    "metadata": {},
    "name": "GlobalShortcutsRelayClientQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "293957e10078d4cb40237c0fdc35aadd";

export default node;
